export enum PanelTypes {
  Blocks = 'blocks-panel',
  Personalization = 'personalization-panel',
  Version = 'version-panel',
  Login = 'login-panel',
  Share = 'share-panel',
  VersionStatus = 'version-status-panel',
  Logout = 'logout-panel',
  Position = 'position-panel',
}

export type Block = { [key: string]: any };

export interface PanelState {
  name: PanelTypes;
  block: Block;
}
